'use client'
import { socket } from '../Containers/MainContainer';

import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PlutoMenu from './PlutoMenu';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';

function PlutoSameEmail(props) {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [users, setUsers] = useState([]);
    const [ip, setIP] = useState([]);
    const [rank, setRank] = useState(0)

    useEffect(() => {

        socket.on('response_get_admin_sameemail_users', (data) => {
            setUsers(data.users)
            setRank(data.rank)
        })

        socket.emit('getSameEmailAdmin', {
            email: props.second_page.split('1').join('%'),
        })

    }, [])
    return (
        <SkeletonTheme baseColor="#0d131c" highlightColor="#111923">
            <div class="modal-body" style={{ color: 'var(--text-primary)' }}>

                <div style={{ overflow: 'auto', margin: '0 auto', padding: '20px', marginBottom: '20px', background: 'var(--accent-1)' }}>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 'bold' }}>Same Email User Details</p>

                    <div style={{ fontWeight: 'bold' }}>
                        <div className="user-details-table-elements" >

                            <div style={{ minWidth: '50px' }} >id</div>
                            <div style={{ minWidth: '250px', textAlign: 'left', color: 'var(--text-primary)' }} >Username</div>
                            <div style={{ minWidth: '250px', textAlign: 'left', color: 'var(--text-primary)' }} >Email</div>
                            <div style={{ minWidth: '100px' }}>Country</div>
                            <div style={{ minWidth: '150px' }}>Join Date</div>
                            <div style={{ minWidth: '150px' }}>Balance</div>

                            <div style={{ minWidth: '150px' }}>Total Earned</div>
                            <div style={{ minWidth: '150px' }}>Banned</div>

                            <div style={{ minWidth: '100px', maxWidth: '100px' }}>Check</div>


                        </div>
                    </div>
                    {users.map((earning, i) => {
                        return (
                            <div key={earning.id} className="user-details-table-elements admin-a" style={{ color: 'var(--text-primary)' }}>

                                <div style={{ minWidth: '50px' }} > {earning.id || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '250px', textAlign: 'left', color: 'var(--text-primary)' }} >{earning.username || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '250px', textAlign: 'left', color: 'var(--text-primary)' }} >{earning.email || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '100px' }} >{earning.country || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', }} >{earning.joinDate || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', }} >{earning.balance || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', }} >{earning.total_earned || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: earning.banned == undefined ? '' : earning.banned == "True" ? 'red' : '', }} >{earning.banned || <Skeleton style={{ width: '30px' }} />}</div>

                                <Link to={`/pluto/user/${earning.id}`} className="btn button-disabled" style={{ minWidth: '100px', height: '30px', display: 'flex', fontSize: '10px', alignItems: 'center', justifyContent: 'center', minWidth: '100px', maxWidth: '100px' }} >{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Check User'}</Link>

                            </div>
                        )
                    })}
                </div>

            </div>

        </SkeletonTheme>
    )
}

export default PlutoSameEmail